module.exports = __webpack_public_path__ + "img/h5.3dbaec76.png";